<div class="mat-dialog-device-details" *ngIf="!isImportSite">
    <form [formGroup]="userForm">
      <div mat-dialog-title class="dialog-title">
        <h2>{{headerName}} 
          <!-- (<span class="inline-icon-text">Export <mat-icon class="inline-icon">arrow_right</mat-icon>
          Delete <mat-icon class="inline-icon">arrow_right</mat-icon>
          Import</span>) -->
        </h2>
        <button mat-icon-button aria-label="close dialog" [mat-dialog-close]="true">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <mat-dialog-content class="mat-typography">
        <div class="move-site-form">
          <mat-grid-list cols="2" rowHeight="100px">
            <mat-grid-tile>
              <div class="w-100">
                <!-- Potential ID input field -->
                <mat-form-field appearance="outline" class="form-feild">
                  <mat-label>Potential ID</mat-label>
                  <input matInput type="text" placeholder="Enter Potential ID" 
                  name="potentialId" formControlName="potentialId" readonly />
                  <mat-error *ngIf="userForm.invalid">
                    {{errorMessageFormField.potentialId}}
                  </mat-error>
                </mat-form-field>
                <p class="note">*Please ensure you export the site before deleting it.</p>                
              </div>
            </mat-grid-tile>
            <mat-grid-tile>
              <div class="w-100">
                <!-- Additional fields can be added here -->
              </div>
            </mat-grid-tile>
          </mat-grid-list>
          <div class="nots-text"></div>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <!-- Replace Move button with Export, Delete, Import buttons -->
        <button mat-raised-button class="export-btn" type="button" (click)="export()" [disabled]="importButton">
          Export
        </button>
        <mat-icon>arrow_forward</mat-icon>
        <button mat-raised-button class="delete-btn" type="button" (click)="delete()" [disabled]="!deleteButton">
          Delete
        </button>
        <!-- <mat-icon>arrow_forward</mat-icon>
        <button mat-raised-button class="import-btn" type="button" (click)="import()" [disabled]="!importButton">
          Import
        </button> -->
      </mat-dialog-actions>
    </form>
  </div>
  <div class="mat-dialog-device-details" *ngIf="isImportSite">
    <form>
      <div mat-dialog-title class="dialog-title">
        <h2>Import Site</h2>
        <button mat-icon-button aria-label="close dialog" [mat-dialog-close]="true">
          <mat-icon>close</mat-icon>
        </button>
      </div>
      <mat-dialog-content class="mat-typography">
        <div class="move-site-form">
          <div class="form-field">
            <!-- Normal dropdown -->
            <mat-form-field appearance="outline" class="importSite">
              <mat-label>Farm Type</mat-label>
              <mat-select (selectionChange)="farmChange($event)">
                <mat-option *ngFor="let farmTyp of farmTypeData;"
                value="{{farmTyp.value}}">{{farmTyp.name}}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          
          <div class="form-field">
            <label>Upload File</label>
            <input type="file" accept="zip,application/zip"
            (change)="onFileSelected($event)" />
            <!-- <p>{{uploadedFile}}</p> -->
          </div>
          
          <div class="notes-text"></div>
        </div>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button mat-raised-button class="import-btn" type="button" (click)="import()" [disabled]="!isImportButtonEnabled()">
          Import
        </button>
      </mat-dialog-actions>
    </form>
  </div>
  
  
  
  